import React from 'react';
import PropTypes from 'prop-types';

class Provider extends React.Component {
    getChildContext() {
        return {
            close: this.props.close
        };
    }

    render() {
        return this.props.children;
    }
}

Provider.childContextTypes = {
    close: PropTypes.func.isRequired,
    children: PropTypes.any
};

Provider.propTypes = {
    close: PropTypes.func.isRequired,
    children: PropTypes.any
};

const connect = (WrapMe) => {
    function Wrapper(props, { close }) {
        return <WrapMe {...props} close={close}/>;
    }

    Wrapper.contextTypes = {
        close: PropTypes.func.isRequired
    };

    Wrapper.displayName = `WithGlobalModalBehavior(${WrapMe.displayName || WrapMe.name || 'Component'})`;

    return Wrapper;
};

export { Provider, connect };
